import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '@mui/material/styles';

export const useUnreadAnnouncementsStyles = makeStyles(
  (theme: Theme) => ({
    kindItemCountContainer: {
      display: 'inline-flex',
      minWidth: '20px',
      height: '20px',
      padding: '0 4px',
      // padding: '.125rem .5rem',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: '10px',
      background: theme.palette?.mode === 'dark' ? '#2EFFAF' : '#00A868',

      fontSize: '.625rem',
      fontWeight: 700,
      color:
        theme.palette?.mode === 'dark' ? 'var(--UI-Gray-25, #404040)' : '#fff',
      marginLeft: '25px',
      boxSizing: 'border-box',
    },
  }),
  { name: 'UnReadAnnoucements' },
);
